
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ConfirmDialog extends Vue {
  @Prop({ default: false }) show!: boolean
  @Prop() title!: string
  @Prop() text!: string
}
